import * as React from 'react';
import { License } from '@services';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { IconCaretDown } from '@tabler/icons';
import Typography from '@mui/material/Typography';
import { ToggleButton } from '../toggle/toggle-button';

const ScopeRenderer = (props: {
    id: string;
    name: string;
    description: string;
    selected?: boolean;
    onChange?: (checked: boolean, id: string) => void;
    disabled?: boolean;
}) => {
    const handleCheckboxChange = (value: boolean) => {
        props.onChange?.(value, props.id);
    };

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'row',
                border: '1px solid',
                marginTop: '3px',
                alignItems: 'center',
                borderRadius: '5px',
                borderColor: '#CCC'
            }}
        >
            <ToggleButton value={props.selected} onChange={handleCheckboxChange} disabled={props.disabled} />
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <b>{props.name}</b>
                {props.description}
            </div>
        </div>
    );
};

const LicenseRenderer = (props: {
    license: License;
    selectedScopes: string[];
    onScopeChange: (scopes: string[], license: License) => void; // returns all the scopes selected
    onScopeModify?: (scope: string, addOrRemove: "add" | "remove") => void; // returns the modified scopes
    disabled?: boolean;
}) => {
    const handleChange = (checked: boolean, id: string) => {
        const currentScope = `${props.license.id}:${id}`;
        if (checked) {
            if (props.selectedScopes.indexOf(currentScope) < 0) {
                props.onScopeChange([...props.selectedScopes, currentScope], props.license);
                props.onScopeModify?.(currentScope, "add");
            }
        } else {
            props.onScopeChange(
                props.selectedScopes.filter((s) => s !== currentScope),
                props.license
            );
            props.onScopeModify?.(currentScope, "remove");
        }
    };

    if (props.license.scopes.length === 0) {
        return null;
    }

    return (
        <Accordion style={{ border: '1px solid', width: '100%', borderRadius: '5px', borderColor: '#777' }}>
            <AccordionSummary expandIcon={<IconCaretDown />}>
                <div>
                    <Typography>{props.license.name}</Typography>
                    <Typography sx={{ color: 'text.secondary' }}>{props.license.description}</Typography>
                </div>
            </AccordionSummary>
            <AccordionDetails>
                {props.license.scopes.map((scope) => {
                    return (
                        <ScopeRenderer
                            id={scope.id}
                            key={scope.id}
                            name={scope.name}
                            description={scope.description}
                            selected={props.selectedScopes.includes(`${props.license.id}:${scope.id}`)}
                            onChange={handleChange}
                            disabled={props.disabled}
                        />
                    );
                })}
            </AccordionDetails>
        </Accordion>
    );
};

export default LicenseRenderer;
